var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compere-block"},[_c('div',{staticClass:"new-block",class:{'new-block__error-box': _vm.hasError}},[_c('input-creator',{class:{'error-input': _vm.hasError},attrs:{"disabled":_vm.disabled,"tip":_vm.proposeExplanation || _vm.explanation,"tip-placement":"right","tipWidth":_vm.tipWidth,"data-type":_vm.filter.data_type,"value":_vm.value,"filter":_vm.filter,"label":_vm.label,"autocompleteEntity":_vm.autocompleteEntity,"rules":_vm.rules},on:{"set-enum-value":function (ref) {
	var value = ref.value;

	return _vm.$emit('change', value);
},"set-input-value":function (ref) {
	var value = ref.value;

	return _vm.$emit('change', value);
}}}),(_vm.errorMsg)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorMsg))]):(_vm.sameValueErr)?_c('p',{staticClass:"error"},[_vm._v("New value cannot equal old")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5da1e48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/challenge-components/ChallengeInputBlock.vue
// module id = null
// module chunks = 